"use client";

import {Button} from "@/components/ui/button";
import {Check} from "lucide-react";
import Link from "next/link";

export default function Content({businessType}) {
    return (
        <div className="bg-[#efecea]">
            <div className="max-w-7xl mx-auto px-6 py-20">
                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    {/* Text Content */}
                    <section>
                        <div className="border border-neutral-700 py-1 px-3.5 rounded-full inline-block mb-6 mt-4">
                            <h1 className="text-smtext-neutral-900 relative mb-0 leading-tight inline-block font-medium">
                                {businessType.title}
                            </h1>
                        </div>
                        <p className="text-5xl text-neutral-800 mb-8 leading-tight">
                            {businessType.description}
                        </p>

                        <div className="space-y-2 mb-10">
                            {businessType.benefits.map((benefit, index) => (
                                <p key={index} className="flex gap-3 items-center text-lg text-neutral-800">
                                <Check />
                                {benefit}
                                </p>
                            ))}
                        </div>

                        <Button asChild variant="primary" className="h-12 bg-fe-primary hover:ring-4 hover:ring-fe-primary/50 hover:fe-primary text-white">
                            <Link href="/signup">Start Your Free Trial</Link>
                        </Button>
                    </section>

                    {/* Metric Card (Inspired by your reference image) */}
                    <section className="">
                        <img src={businessType.image_url} className="rounded-3xl max-h-[600px] w-full object-cover"
                             alt=""/>
                    </section>
                </div>
            </div>
        </div>
    )
}